import { ChevronRight } from 'lucide-react';
import styled from 'styled-components';

import { ClienteVendaListItem } from '../../../../../../types/cliente-venda';
import { formatDateTime, formatPreco } from './format';
import { VendaStatusBadge } from './venda-status-badge';
import { VendaUpsellBadge } from './venda-upsell-badge';

interface Props {
  items: ClienteVendaListItem[];
  onOpen: (id: string) => void;
}

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const Item = styled.li`
  background: ${({ theme }) => theme.colors.bgSurface};
  border: 1px solid ${({ theme }) => theme.colors.border};
  border-radius: ${({ theme }) => theme.radius.lg};
`;

const Card = styled.button`
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 8px;
  padding: 16px;
  background: transparent;
  border: none;
  border-radius: inherit;
  cursor: pointer;
  color: inherit;

  &:hover {
    background: ${({ theme }) => theme.colors.bgMuted};
  }
`;

const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  grid-column: 1 / -1;
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  line-height: 1.3;

  strong {
    font-weight: 600;
  }
  small {
    color: ${({ theme }) => theme.colors.textMuted};
    font-size: 12.5px;
  }
`;

const BadgeRow = styled.div`
  display: flex;
  gap: 4px;
  flex-wrap: wrap;
`;

const Meta = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12.5px;
  color: ${({ theme }) => theme.colors.textMuted};
  margin-top: 4px;
`;

const buyerName = (item: ClienteVendaListItem): string =>
  `${item.comprador.nome ?? ''} ${item.comprador.sobrenome ?? ''}`.trim() ||
  '—';

export const VendasCards = ({ items, onOpen }: Props) => (
  <List>
    {items.map((v) => (
      <Item key={v.id}>
        <Card
          onClick={() => onOpen(v.id)}
          data-testid={`venda-card-${v.id}`}
        >
          <Top>
            <Info>
              <strong>{v.produto.nome ?? '—'}</strong>
              <small>{buyerName(v)}</small>
            </Info>
            <BadgeRow>
              <VendaStatusBadge
                status={v.status}
                descricao={v.statusDescricao}
              />
              <VendaUpsellBadge upsell={v.upsell} />
            </BadgeRow>
          </Top>
          <Info>
            <strong>{formatPreco(v.valor, v.moedaSigla)}</strong>
            {v.metodoPagamentoDescricao && (
              <small>{v.metodoPagamentoDescricao}</small>
            )}
          </Info>
          <Meta>
            <span>{formatDateTime(v.createdAt)}</span>
            <ChevronRight size={16} />
          </Meta>
        </Card>
      </Item>
    ))}
  </List>
);
